import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CadastreHeader from "../headers/cadastre.header";
import CategoryCadastreForm from "./forms/category.cadastre.form";
import CategoryCadastreList from "./lists/category.cadastre.list";
import { useTranslateContext } from "../../contexts/translate.context";

export interface ICategoryCadastreProps {
}

export const CategoryCadastre: React.FC<ICategoryCadastreProps> = (props: ICategoryCadastreProps) => {

    const { categoryId  } = useParams();
    const { display } = useTranslateContext();

    const title = display.title.category;
    const description = '';

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ recordSelected, setRecordSelected ] = useState({ param : categoryId || '', selected : ((categoryId === 'new') || (categoryId === '0') || (!Number.isNaN(Number.parseInt(categoryId ||'')))) });

    function setSelected(isRecord: boolean, recordId: string) {
        setRecordSelected({ param : recordId, selected : isRecord });
    }

    async function initialize() {
    }
  
    useEffect(() => {
        if (!isLoading && !reloadPage) {
            initialize();
            setLoading(true);
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []);
    
    return (
        <div className="page">
            <CadastreHeader title={title} description={description} />
            {(recordSelected.selected) ? (
                <CategoryCadastreForm 
                    title={title}
                    categoryId={recordSelected.param}
                    setRecord={(event: any) => { 
                        event.preventDefault();
                        setSelected(false, '0'); 
                    }} 
                />
            ) : (
                <CategoryCadastreList 
                    title={title}
                    setRecord={(event: any, recordId: string) => { 
                        event.preventDefault();
                        setSelected(true, recordId); 
                    }}
                />
            )}
        </div>
    )
}

export default CategoryCadastre;
